import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Entreprise } from 'src/app/data/intervenant/models/entreprise.model';
import { DeclarationsService } from 'src/app/data/declaration/services/declarations/declarations.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { filter, map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-declarations',
    templateUrl: './declarations.component.html',
    styleUrls: ['./declarations.component.scss'],
    standalone: false
})
export class DeclarationsComponent implements OnInit, OnDestroy {
    selectedEntreprise: Entreprise;
    activeIdString: string;
    masquageOngletsEtRecherche: false;
    subscription: any;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        public readonly declarationService: DeclarationsService,
        private readonly authService: AuthService
    ) {}

    ngOnInit() {
        this.masquageOngletsEtRecherche =
            this.route.snapshot &&
            this.route.snapshot.children[0] &&
            this.route.snapshot.children[0].data &&
            this.route.snapshot.children[0].data.masquageOngletsEtRecherche;

        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => this.route),
                map(route => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                switchMap(route => route.data)
            )
            .subscribe(data => {
                this.masquageOngletsEtRecherche = data.masquageOngletsEtRecherche;
            });

        if (!this.isAnpp()) {
            this.declarationService.entrepriseSelectionnee = null;
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public onTabChange($event: NgbNavChangeEvent): void {
        switch ($event.nextId) {
            case 'vergers':
                this.router.navigate(['/main/declarations-pp/parcellaire']);
                break;
            case 'recoltes':
                this.router.navigate(['/main/declarations-pp/recoltes']);
                break;
            case 'stocks':
                this.router.navigate(['/main/declarations-pp/stocks']);
                break;
            case 'ecoulements':
                this.router.navigate(['/main/declarations-pp/ecoulements']);
                break;
        }
    }

    addItem(newItem: Entreprise) {
        this.declarationService.entrepriseSelectionnee = newItem;
        this.selectedEntreprise = newItem;
        let entrepriseUrl = '';
        if (this.declarationService.entrepriseSelectionnee) {
            entrepriseUrl = '/' + this.declarationService.entrepriseSelectionnee.id;
        }
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        switch (this.declarationService.activeTabId) {
            case 'vergers':
                this.router.navigated = false;
                this.router.navigate(['/main/declarations-pp/parcellaire' + entrepriseUrl]);
                break;
            case 'recoltes':
                this.router.navigate(['/main/declarations-pp/recoltes' + entrepriseUrl]);
                break;
            case 'stocks':
                this.router.navigate(['/main/declarations-pp/stocks' + entrepriseUrl]);
                break;
            case 'ecoulements':
                this.router.navigate(['/main/declarations-pp/ecoulements' + entrepriseUrl]);
                break;
        }
    }

    isAnpp() {
        return this.authService.isAnpp();
    }
}
